import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";

import Login from "./containers/Auth/Login";
import Signup from "./containers/Auth/Signup";
import PasswordReset from "./containers/Auth/PasswordReset";
import PasswordResetConfirm from "./containers/Auth/PasswordResetConfirm";
import Dashboard from './containers/Dashboard/DashboardView';
import LeadDetail from './containers/Leads/LeadDetail';
import LeadView from "./containers/Leads/LeadView";
import ContactView from "./containers/Contacts/ContactView";
import TaskView from "./containers/Tasks/TaskView";
// import TaskCalendar from './containers/Tasks/TaskCalendar';
import TaskCalendar from './containers/Tasks/ViewAsCalendar';
import EventCalendar from './containers/Events/EventCalendar';
import EventView from './containers/Events/EventView';
import ProfileView from './containers/Profile/ProfileView';
import EmailView from './containers/Email/EmailView';
import ClientZoneView from './containers/ClientZone/ClientZoneView';
import ClientServiceView from './containers/ClientZone/ClientServiceView';

import Error404 from './containers/Layout/Error404';
// import PrivateRoute from './containers/Auth/PrivateRoute';

export const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route {...rest} render={props => (
    localStorage.getItem('token')
      ? <Component {...props} />
      : <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
  )} />
)

class BaseRouter extends React.Component {
  render() {
    if (this.props.role === 'ADMIN') {
      return (
        <Switch>
          <Route exact path="/login/" component={Login} />{" "}
          <Route exact path="/password_reset/" component={PasswordReset} />
          <PrivateRoute exact path="/" component={Dashboard} />
          <PrivateRoute exact path="/leads/" component={LeadView} />
          <PrivateRoute exact path="/leads/:leadID/" component={LeadDetail} />
          <PrivateRoute exact path="/leads/create/" component={LeadDetail} />
          <PrivateRoute exact path="/contacts/" component={ContactView} />
          <PrivateRoute exact path="/tasks/" component={TaskView} />
          <PrivateRoute exact path="/tasks/calendar/" component={TaskCalendar} />
          <PrivateRoute exact path="/events/" component={EventView} />
          <PrivateRoute exact path="/events/calendar/" component={EventCalendar} />
          <PrivateRoute exact path="/profile/" component={ProfileView} />
          <PrivateRoute exact path="/email/" component={EmailView} />
          <Route component={Error404} />
        </Switch>
      );
    } else {
      return (
        <Switch>
          <Route exact path="/login/" component={Login} />{" "}
          <Route exact path="/password_reset/" component={PasswordReset} />
          <Route exact path="/password_reset/confirm/:uid/:token/" component={PasswordResetConfirm} />
          {/* <Route exact path="/signup/" component={Signup} />{" "} */}
          <PrivateRoute exact path="/" component={ClientZoneView} />
          <PrivateRoute exact path="/services/" component={ClientServiceView} />
          <Route component={Error404} />
        </Switch>
      );
    }
  }

}

export default BaseRouter;



// WEBPACK FOOTER //
// ./src/routes.js